  document.addEventListener("DOMContentLoaded", function () {
    const tabs = document.querySelectorAll(".ma-tab-link");
    const panes = document.querySelectorAll(".ma-tab-pane");

    tabs.forEach(tab => {
      tab.addEventListener("click", () => {
        // Remove active classes
        tabs.forEach(t => t.classList.remove("active"));
        panes.forEach(p => p.classList.remove("active"));

        // Add active class to selected
        tab.classList.add("active");
        document.getElementById(tab.dataset.tab).classList.add("active");
      });
    });
  });